import { forwardRef, HTMLAttributes } from "react";
import * as SC from "./tip.styles";
import { ShapeIcon } from "../../atoms/ShapeIcon/shape-icon";

const Root = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ children, ...props }, ref) => (
    <SC.Background ref={ref} {...props}>
      {children}
    </SC.Background>
  )
);

const Content = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ children, ...props }, ref) => (
    <SC.Content ref={ref} {...props}>
      {children}
    </SC.Content>
  )
);

export const Tip = {
  Root,
  Icon: ShapeIcon,
  Content,
};
